// @flow strict

import * as React from 'react';

function ServicesPage() {
    return (
        <div className="p-6">
            <h1 className="font-poppins font-semibold text-[18px] text-title mb-4">
                Nos Services
            </h1>
            <p className="font-nunito text-[14px] text-text">
                Découvrez notre gamme complète de services de coiffure et de bien-être.
            </p>
        </div>
    );
};

export default ServicesPage;